module.exports = __webpack_public_path__ + "static/media/topimage01withtext.f223be7a.png";